import React, { useState } from 'react';
import INDIA_HOLIDAYS from '../utils/holidays';

function SidebarCalendar({ db, setPage }) {
  const now = new Date();
  const [viewYear, setViewYear] = useState(now.getFullYear());
  const [viewMonth, setViewMonth] = useState(now.getMonth());

  const today = now.getDate();
  const todayMonth = now.getMonth();
  const todayYear = now.getFullYear();

  const DAYS = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
  const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const firstDay = new Date(viewYear, viewMonth, 1).getDay();
  const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();

  // Exams on each date this month
  const examDates = new Set(
    db.exams
      .filter(e => e.dt && new Date(e.dt).getFullYear() === viewYear && new Date(e.dt).getMonth() === viewMonth)
      .map(e => new Date(e.dt).getDate())
  );

  const prevMonth = () => { if (viewMonth === 0) { setViewMonth(11); setViewYear(y => y - 1); } else setViewMonth(m => m - 1); };
  const nextMonth = () => { if (viewMonth === 11) { setViewMonth(0); setViewYear(y => y + 1); } else setViewMonth(m => m + 1); };

  const cells = [];
  for (let i = 0; i < firstDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  const isToday = d => d === today && viewMonth === todayMonth && viewYear === todayYear;
  const hasExam = d => examDates.has(d);

  return (
    <div className="mx-3 mb-3 bg-surface-container-lowest rounded-2xl p-4 shadow-sm border border-surface-container-high">
      {/* Header */}
      <div className="flex items-center justify-between mb-3">
        <button onClick={prevMonth} className="w-6 h-6 flex items-center justify-center rounded-lg hover:bg-surface-container transition-colors border-0 bg-transparent cursor-pointer">
          <span className="material-symbols-outlined text-[14px] text-slate-500">chevron_left</span>
        </button>
        <button onClick={() => { setViewMonth(todayMonth); setViewYear(todayYear); }}
          className="text-xs font-black text-primary tracking-wide border-0 bg-transparent cursor-pointer hover:opacity-70 transition-opacity">
          {MONTHS[viewMonth]} {viewYear}
        </button>
        <button onClick={nextMonth} className="w-6 h-6 flex items-center justify-center rounded-lg hover:bg-surface-container transition-colors border-0 bg-transparent cursor-pointer">
          <span className="material-symbols-outlined text-[14px] text-slate-500">chevron_right</span>
        </button>
      </div>

      {/* Day headers */}
      <div className="grid grid-cols-7 mb-1">
        {DAYS.map((d, i) => (
          <div key={i} className="text-center text-[9px] font-black text-slate-400 uppercase py-0.5">{d}</div>
        ))}
      </div>

      {/* Date grid */}
      <div className="grid grid-cols-7 gap-y-0.5">
        {cells.map((d, i) => (
          <div key={i} className="flex items-center justify-center">
            {d ? (
              <div className={`relative w-7 h-7 flex items-center justify-center rounded-lg text-[11px] font-bold cursor-pointer transition-all
                ${isToday(d) ? 'bg-primary text-white shadow-sm shadow-primary/30' : 'hover:bg-surface-container text-on-surface'}`}
                onClick={() => hasExam(d) && setPage('exam')}>
                {d}
                {hasExam(d) && !isToday(d) && (
                  <span className="absolute bottom-0.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-error"></span>
                )}
                {hasExam(d) && isToday(d) && (
                  <span className="absolute bottom-0.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-white"></span>
                )}
              </div>
            ) : <div className="w-7 h-7" />}
          </div>
        ))}
      </div>

      {/* Legend */}
      <div className="flex items-center gap-3 mt-3 pt-3 border-t border-slate-100">
        <div className="flex items-center gap-1.5">
          <div className="w-2 h-2 rounded-full bg-primary"></div>
          <span className="text-[9px] font-bold text-slate-400 uppercase tracking-wide">Today</span>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="w-2 h-2 rounded-full bg-error"></div>
          <span className="text-[9px] font-bold text-slate-400 uppercase tracking-wide">Exam</span>
        </div>
      </div>
    </div>
  );
}


export default SidebarCalendar;
